import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  makePost,
  makePrivilagedPost,
  makePrivilagedPostForFile,
} from "../../utils/fetchUtils";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LOGIN,
  SEND_OTP,
  VALIDATE_OTP_LOGIN,
  WHITELIST_MULTIPLE_EMAILS,
  WHITELIST_MULTIPLE_NUMBERS,
  WHITELIST_SINGLE_EMAIL,
  WHITELIST_SINGLE_NUMBER,
} from "../../utils/constants";
import { setTimeout } from "timers/promises";
import { getRoles } from "@testing-library/react";
import { ErrorObj } from "../../utils/types";
import UserActivityList from "../../components/UserActivityList";

const WhiteList = () => {
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fileName, setFileName] = useState("");
  const [access, setAccess] = useState(false);
  const [error, setError] = useState<ErrorObj>({});
  const [displayStatus, setDisplayStatus] = useState<
    "checkUser" | "addNumber" | "addEmail"
  >("checkUser");
  const [formData, setFormData] = useState<any>({
    file: null,
    fileName: "",
  });
  const [success,setSuccess] = useState(false);

  useEffect(() => {
    document.title = "Whitelist - Nclude Portal";
  }, []);

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);
  // },[error])

  useEffect(()=> {
    if(success) {
      window.setTimeout(() => {
        setSuccess(false);
      },1000);
    }

  },[success])

  const handleAccess = (event: any): void => {
    const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;
    const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;
    // console.log(ADMIN_EMAIL);
    if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
      setAccess(true);
    } else {
      setError({
        system: "Wrong credentials. Access denied",
      });
    }
  };

  function selectNavMenu(event: any): void {
    throw new Error("Function not implemented.");
  }

  function checkUser(event: any): void {
    throw new Error("Function not implemented.");
  }

  const validateEmail = () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      return false;
    } else {
      return true;
    }
  };

  const validateNumber = () => {
    if (!/^\d*$/.test(phoneNumber)) {
      return false;
    } else if (phoneNumber.length !== 10) {
      return false;
    } else {
      return true;
    }
  };

  function whiteListSingleNumber(event: any): void {
    if (!validateNumber()) {
      setError({
        system: "Please enter a valid phone number",
      });
      return;
    }
    const payload = {
      phoneNumber: phoneNumber,
    };
    const url = WHITELIST_SINGLE_NUMBER;
    const secret = process.env.REACT_APP_PRIVILAGE_KEY;
    makePrivilagedPost(url, payload,secret)
      .then((response) => {
        console.log(response);
        setSuccess(true);
        setFormData({
          file: null,
          fileName: "",
        });
        setFileName("");
        setError({});
      })
      .catch((error) => console.log(error));
  }

  function whiteListMultipleNumbers(event: any): void {
    const data = new FormData();
    if (formData.file) {
      data.append("file", formData.file);
    }

    console.log("Form data:", formData);
    const url = WHITELIST_MULTIPLE_NUMBERS;
    const secret = process.env.REACT_APP_PRIVILAGE_KEY;
    makePrivilagedPostForFile(url, data,secret)
      .then((response) => {
        console.log(response);
        setSuccess(true);
        setFormData({
          file: null,
          fileName: "",
        });
        setFileName("");
        setError({});
      })
      .catch((err) => console.log(err));
  }

  function whiteListMultipleEmails(event: any): void {
    const data = new FormData();
    if (formData.file) {
      data.append("file", formData.file);
    }

    console.log("Form data:", formData);
    const url = WHITELIST_MULTIPLE_EMAILS;
    const secret = process.env.REACT_APP_PRIVILAGE_KEY;
    makePrivilagedPostForFile(url, data,secret)
      .then((response) => {
        console.log(response);
        setSuccess(true);
        setFormData({
          file: null,
          fileName: "",
        });
        setFileName("");
        setError({});
      })
      .catch((err) => console.log(err));
  }

  function whiteListSingleEmail(event: any): void {
    if (!validateEmail()) {
      setError({
        system: "Please enter a valid email address",
      });
      return;
    }

    const payload = {
      email: email,
    };
    const url = WHITELIST_SINGLE_EMAIL;
    const secret = process.env.REACT_APP_PRIVILAGE_KEY;
    makePrivilagedPost(url, payload,secret)
      .then((response) => {
        console.log(response);
        setSuccess(true);
        setFormData({
          file: null,
          fileName: "",
        });
        setFileName("");
        setError({});
      })
      .catch((error) => console.log(error));
  }

  function viewCsv(event: any): void {
    throw new Error("Function not implemented.");
  }

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setFileName(file.name);
      setFormData({
        ...formData,
        file: files ? files[0] : null,
        fileName: file.name,
      });
    } else {
      setFileName(event.target.value);
      setFormData({
        ...formData,
        fileName: event.target.value,
      });
    }
  };

  return (
    <div className="flex justify-content-center items-center login-form">
      {!access && (
        <>
          <div className="logo-container">
            <img
              src="https://documents2.istemai.com/assets/istem_logo.png"
              alt="I-stem logo"
              className="logo-img-login"
            />
          </div>
          <div className="auth-form-container flex flex-col items-center">
            <h1 className="my-12 text-[2.375rem]">Whitelist Numbers</h1>

            <div className="flex flex-col">
              {error.system && (
                <p className="text-center mt-6 text-[#FF0000]" role="alert">
                  {error.system}
                </p>
              )}
              {
                <>
                  <label htmlFor="email" className="mt-12">
                    Enter Email Address
                  </label>
                  <input
                    className="text-black w-[31.25rem] h-[3.4rem] rounded px-4"
                    placeholder="user@gmail.com"
                    id="email"
                    type="email"
                    value={email}
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      setEmail(value);
                      setError({
                        email: "",
                        password: "",
                        phone: "",
                        system: "",
                      });
                    }}
                  />
                  {error.email && (
                    <p
                      className="text-center mt-2 mb-0 text-[#FF0000]"
                      role="alert"
                    >
                      {error.email}
                    </p>
                  )}
                </>
              }

              {
                <>
                  <label htmlFor="password" className="mt-12">
                    Enter Password
                  </label>
                  <input
                    className="text-black w-[31.25rem] h-[3.4rem] rounded px-4"
                    id="password"
                    type="password"
                    placeholder="8+ characters"
                    value={password}
                    required
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                  {error.password && (
                    <p
                      className="text-center mt-2 mb-0 text-[#FF0000]"
                      role="alert"
                    >
                      {error.password}
                    </p>
                  )}
                </>
              }

              {
                <button
                  className="mt-12 bg-[#4f00ec] w-[31.25rem] h-[3.125rem] rounded"
                  onClick={handleAccess}
                >
                  {"Submit"}
                </button>
              }
              <h2 style={{ fontSize: "1.2rem" }} className="mt-4 text-right">
                <Link to="/" className="text-[#00DAF7]">
                  Go Back to home Page
                </Link>
              </h2>

              {/* <p className='text-center mt-6 text-[#FF0000]'>{error}</p> */}
            </div>
          </div>
        </>
      )}
      {access && (
        <div className="page-container">
          <div
            className="doc-container"
            role="main"
            tabIndex={-1}
            style={{ width: "100%" }}
          >
            <h1 className="display-title center" ref={mainRef} tabIndex={-1}>
              White list Users
            </h1>
            <div className="component-container form-container d-flex justify-content-center">
              <div className="border-2 border-white my-8 w-[80%] whitelist-navbar">
                <nav
                  aria-label="Browse selection navigation region"
                  className="d-flex justify-content-between"
                >
                  <button
                    className={`py-4 mr-12 ${
                      displayStatus === "checkUser"
                        ? "text-[#9AFE43] border-b-2 border-[#9AFE43]"
                        : ""
                    }`}
                    onClick={() => {
                      setDisplayStatus("checkUser");
                      setFormData({
                        file: null,
                        fileName: "",
                      });
                      setFileName("");
                      setError({});
                    }}
                  >
                    Check User
                  </button>
                  <button
                    className={`py-4 mr-12 ${
                      displayStatus === "addNumber"
                        ? "text-[#9AFE43] border-b-2 border-[#9AFE43]"
                        : ""
                    }`}
                    onClick={() => {
                      setDisplayStatus("addNumber");
                      setFormData({
                        file: null,
                        fileName: "",
                      });
                      setFileName("");
                      setError({});
                    }}
                  >
                    WhiteList Numbers
                  </button>
                  <button
                    className={`py-4 mr-12 ${
                      displayStatus === "addEmail"
                        ? "text-[#9AFE43] border-b-2 border-[#9AFE43]"
                        : ""
                    }`}
                    onClick={() => {
                      setDisplayStatus("addEmail");
                      setFormData({
                        file: null,
                        fileName: "",
                      });
                      setFileName("");
                      setError({});
                    }}
                  >
                    WhiteList Emails
                  </button>
                </nav>
              </div>
              {success && (
            <div role="alert" className="d-flex w-[90%] otp-sent-alert mt-5 whitelisted-toast">
              <p>Successfully Whitelisted</p>
            </div>
          )}
              {displayStatus === "checkUser" && (
                <>
                  <div className="page-body d-flex flex-wrap justify-content-center">
                    <div className="d-flex flex-wrap justify-content-center single-body">
                      <h2 className="mt-12 w-[70%] d-flex justify-content-center display-title">
                        Enter the phone Number
                      </h2>
                      <p className="w-[100%] mt-6 d-flex justify-content-center display-6 w-[70%]">
                        Enter the user's phone number here to check whether the
                        user is whitelisted or not!
                      </p>
                      <div className="input-div w-[50%] d-flex flex-wrap justify-content-center">
                        <label
                          htmlFor="phonenumber"
                          className="w-[100%] d-flex flex-wrap justify-content-center"
                        >
                          User's phone number
                        </label>
                        <input
                          type="text"
                          id="phonenumber"
                          className="text-black w-[21.875rem] h-[3.4rem] rounded px-4 mt-12"
                          onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                      </div>
                      <div>
                        <button
                          onClick={checkUser}
                          className={`mt-12 bg-[#4f00ec] w-[21.875rem] h-[3.125rem] rounded`}
                        >
                          Check Access
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {displayStatus === "addNumber" && (
                <>
                  <div className="page-body w-[100%]">
                    <div className="add-user-container w-[100%] d-flex">
                      <div className="single w-[50%] h-[100%] d-flex justify-content-center flex-wrap py-12">
                        <h2>Add Single User</h2>
                        <p>
                          Enter User's phone number to add him/her to the IVR
                          library
                        </p>
                        <div className="input-div w-[50%] d-flex flex-wrap justify-content-center py-12">
                        {error.system && (
                          <p
                            className="text-center mt-6 text-[#FF0000] w-[100%]"
                            role="alert"
                          >
                            {error.system}
                          </p>
                        )}
                          <label
                            htmlFor="phonenumber"
                            className="w-[100%] d-flex flex-wrap justify-content-center"
                          >
                            User's phone number
                          </label>
                          <input
                            type="text"
                            id="phonenumber"
                            className="text-black w-[21.875rem] h-[3.4rem] rounded px-4 mt-12"
                            onChange={(e) => setPhoneNumber(e.target.value)}
                          />
                        </div>
                        <div>
                          <button
                            onClick={whiteListSingleNumber}
                            className={`bg-[#4f00ec] w-[21.875rem] h-[3.125rem] rounded`}
                          >
                            Add User Number
                          </button>
                        </div>
                      </div>
                      <div className="multiple w-[50%] h-[100%] d-flex justify-content-center flex-wrap py-12">
                        <h2>Add Multiple Users</h2>
                        <p>
                          Upload a csv file with numbers to add multiple Users
                          (download the sample csv file to see the format)
                        </p>
                        <div>
                          <a
                            style={{ display: "block", color: "white" }}
                            href="/sample csv for daisy users - Sheet1 (2).csv"
                            className={`bg-[#4f00ec] w-[21.875rem] h-[3.125rem] rounded my-6 d-flex justify-content-center align-items-center`}
                          >
                            View CSV File Format
                          </a>
                        </div>
                        <div className="my-12 w-[21.875rem]">
                          <label htmlFor="formFile">Choose CSV File</label>
                          <input
                            className="form-control input-1 w-[21.875rem]"
                            type="file"
                            id="formFile"
                            name="file"
                            accept=".xls,.xlsx,.csv"
                            aria-describedby="fileHelp"
                            aria-labelledby="formFileLabel"
                            onChange={handleFileChange}
                            required
                          />
                          <label
                            htmlFor="formFile"
                            className="upload-button csv-upload"
                            role="button"
                          >
                            {fileName === "" ? "Upload File" : "Change File"}
                          </label>
                          <p className="filename">{fileName}</p>
                        </div>
                        <div>
                          <button
                            onClick={whiteListMultipleNumbers}
                            className={`bg-[#4f00ec] w-[21.875rem] h-[3.125rem] rounded my-6`}
                            disabled={!formData.file}
                          >
                            Add Users
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {displayStatus === "addEmail" && (
                <>
                  <div className="page-body w-[100%]">
                    <div className="add-user-container w-[100%] d-flex">
                      <div className="single w-[50%] h-[100%] d-flex justify-content-center flex-wrap py-12">
                        <h2>Add Single User</h2>
                        <p>
                          Enter User's phone number to add him/her to the IVR
                          library
                        </p>
                        <div className="input-div w-[50%] d-flex flex-wrap justify-content-center py-12">
                        {error.system && (
                          <p
                            className="text-center mt-6 text-[#FF0000] w-[100%]"
                            role="alert"
                          >
                            {error.system}
                          </p>
                        )}
                          <label
                            htmlFor="phonenumber"
                            className="w-[100%] d-flex flex-wrap justify-content-center"
                          >
                            User's email address
                          </label>
                          <input
                            type="text"
                            id="email"
                            className="text-black w-[21.875rem] h-[3.4rem] rounded px-4 mt-12"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                        <div>
                          <button
                            onClick={whiteListSingleEmail}
                            className={`bg-[#4f00ec] w-[21.875rem] h-[3.125rem] rounded`}
                          >
                            Add User Email
                          </button>
                        </div>
                      </div>
                      <div className="multiple w-[50%] h-[100%] d-flex justify-content-center flex-wrap py-12">
                        <h2>Add Multiple Users</h2>
                        <p>
                          Upload a csv file with numbers to add multiple Users
                          (download the sample csv file to see the format)
                        </p>
                        <div>
                          <a
                            style={{ display: "block", color: "white" }}
                            href="/sample Emails csv - Sheet1 (1).csv"
                            className={`bg-[#4f00ec] w-[21.875rem] h-[3.125rem] rounded my-6 d-flex justify-content-center align-items-center`}
                          >
                            View CSV File Format
                          </a>
                        </div>
                        <div className="my-12 w-[21.875rem]">
                          <label htmlFor="formFile">Choose CSV File</label>
                          <input
                            className="form-control input-1 w-[21.875rem]"
                            type="file"
                            id="formFile"
                            name="file"
                            accept=".xls,.xlsx,.csv"
                            aria-describedby="fileHelp"
                            aria-labelledby="formFileLabel"
                            onChange={handleFileChange}
                            required
                          />
                          <label
                            htmlFor="formFile"
                            className="upload-button csv-upload"
                            role="button"
                          >
                            {fileName === "" ? "Upload File" : "Change File"}
                          </label>
                          <p className="filename">{fileName}</p>
                        </div>
                        <div>
                          <button
                            disabled={!formData.file}
                            onClick={whiteListMultipleEmails}
                            className={`bg-[#4f00ec] w-[21.875rem] h-[3.125rem] rounded my-6`}
                          >
                            Add Users
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhiteList;
